import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csconditionoper(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Conditional Operator tutorial For Beginners</title>
 <meta name="description" content="C# Conditional Operator tutorial for beginners.Conditional Operator in C# if expression 1 is true (if a value is non-zero), then the value returned will be expression 2, otherwise the value returned will be expression 3,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Conditional Operator,c# Conditional Operator for,c sharp Conditional Operator,c# Conditional Operator for loop,end for loop c#,Conditional Operator foreach c#,c# foreach Conditional Operator" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-conditional-operator" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">The Conditional operator in CSharp(C#)</h1>
    
    <div className="first">
        <a href="/csharp-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
  

<h2 className='headings'>The Syntax for a conditional operator in C#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
            <span className="qwerty-4">Expression</span>
            <span className="qwerty-5"> 1</span>
            <span className="qwerty-10">? </span>
            <span className="qwerty-3">Expression </span>
            <span className="qwerty-7">2</span>
            <span className="qwerty-3">: </span>
            <span className="qwerty-3">expression</span>
            <span className="qwerty-2"> 3</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className='headings'>Example of the conditional operator in C# :</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}  
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">if</span>
            <span className="qwerty-7">_else  </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-6">static </span>
            <span className="qwerty-5">void Main</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">string </span>
            <span className="qwerty-10">[] </span>
            <span className="qwerty-4">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">  int </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-10">,</span>
            <span className="qwerty-3">b</span>
            <span className="qwerty-10">;</span>
            {"\n"}
            <span className="qwerty-2">  a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-1">200</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">  b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">(</span>
              <span className="qwerty-3">a</span>
            <span className="qwerty-10"> &#62; </span>
            <span className="qwerty-10">50</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-1"> ?</span>
            <span className="qwerty-3"> 100</span>
            <span className="qwerty-5"> : </span>
            <span className="qwerty-10">25</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">  Console.</span>
            <span className="qwerty-3">WriteLine </span>
            <span className="qwerty-4">(</span>
            <span className="qwerty-1">" </span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-10">is</span>
            <span className="qwerty-6">.</span>
            <span className="qwerty-1">" </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-4">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background:'#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-10">b</span>
              <span className="qwerty-1"> is </span>
              <span className="qwerty-7">:</span>
              <span className="qwerty-4"> 100</span>
              {"\n"}  {"\n"}
            </code>
          </pre>
        </div>
      </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csconditionoper;